import { values } from 'lodash'
import { createSelector } from 'reselect'

import moment from 'moment'

import { PICTURE_DEBUG, SERVER_URL } from 'Global/constants'
import { isRole } from 'Global/Helpers/userHelpers'
import { isWellShaped } from 'Global/Helpers/objectHelpers'

const _recentMFD = state => state.recent.recentMarkedForDesigners
const _recentOrders = state => state.recent.recentOrders
const _recent = state => state.recent.recent

export const currentIndex = state => state.previewModal.index
export const errors = state => state.recent.errors
export const pendings = state => state.recent.pendings
export const previewExpanded = state => state.previewModalMain.expanded
export const previewOpen = state => state.previewModalMain.visible
export const previewRugType = state => state.previewModalMain.rugType
export const statistics = state => state.statistics.data
export const user = state => state.auth.user

export const recent = createSelector(
  [_recent, _recentMFD, _recentOrders, user],
  (recentRugs, recentMFD, recentOrders, user) => {
    const recentMFDLength = values(recentMFD).length
    const recentOrdersLength = values(recentOrders).length

    if (isRole(user, 'designer')) {
      return values(recentRugs)
        .sort((a, b) => moment.utc(b.dateScanned).diff(moment.utc(a.dateScanned)))
        .slice(0, recentMFDLength === 0 ? 6 : 3)
    }

    if (isRole(user, 'advisor') && !isRole(user, 'designer')) {
      return values(recentRugs)
        .sort((a, b) => moment.utc(b.dateScanned).diff(moment.utc(a.dateScanned)))
        .slice(0, recentOrdersLength === 0 ? 6 : 3)
    }

    return values(recentRugs)
  },
)

export const recentMarkedForDesigners = createSelector(
  [_recentMFD],
  rugs => values(rugs),
)

export const recentOrders = createSelector(
  [_recentOrders],
  rugs => values(rugs),
)

export const currentPicture = createSelector(
  [previewRugType, recent, recentMarkedForDesigners, recentOrders, currentIndex],
  (rugType, recentRugs, recentMFDs, recentOrders, index) => {
    if (index > -1) {
      switch (rugType) {
        case 'recent':
          if (isWellShaped(recentRugs[index], 'pictureBig')) {
            if (PICTURE_DEBUG) {
              return PICTURE_DEBUG
            } else {
              return `${SERVER_URL}${recentRugs[index].pictureBig}`
            }
          }

          return ''

        case 'recentMFD':
          if (isWellShaped(recentMFDs[index], 'pictureBig')) {
            if (PICTURE_DEBUG) {
              return PICTURE_DEBUG
            } else {
              return `${SERVER_URL}${recentMFDs[index].pictureBig}`
            }
          }

          return ''

        case 'recentOrders':
          if (isWellShaped(recentOrders[index], 'pictureBig')) {
            if (PICTURE_DEBUG) {
              return PICTURE_DEBUG
            } else {
              return `${SERVER_URL}${recentOrders[index].pictureBig}`
            }
          }

          return ''

        default:
          return ''
      }
    }

    return ''
  },
)

export const currentRug = createSelector(
  [previewRugType, recent, recentMarkedForDesigners, recentOrders, currentIndex],
  (rugType, recentRugs, recentMFDs, recentOrders, index) => {
    if (index > -1) {
      switch (rugType) {
        case 'recent':
          return recentRugs[index] || {}

        case 'recentMFD':
          return recentMFDs[index] || {}

        case 'recentOrders':
          return recentOrders[index] || {}

        default:
          return {}
      }
    }

    return {}
  },
)

export const nextPicture = createSelector(
  [previewRugType, recent, recentMarkedForDesigners, recentOrders, currentIndex],
  (rugType, recentRugs, recentMFDs, recentOrders, index) => {
    if (index > -1) {
      switch (rugType) {
        case 'recent':
          if (isWellShaped(recentRugs[index + 1], 'pictureBig')) {
            return true
          }

          return false

        case 'recentMFD':
          if (isWellShaped(recentMFDs[index + 1], 'pictureBig')) {
            return true
          }

          return false

        case 'recentOrders':
          if (isWellShaped(recentOrders[index + 1], 'pictureBig')) {
            return true
          }

          return false

        default:
          return false
      }
    }

    return false
  },
)

export const previousPicture = createSelector(
  [previewRugType, recent, recentMarkedForDesigners, recentOrders, currentIndex],
  (rugType, recentRugs, recentMFDs, recentOrders, index) => {
    if (index > -1) {
      switch (rugType) {
        case 'recent':
          if (isWellShaped(recentRugs[index - 1], 'pictureBig')) {
            return true
          }

          return false

        case 'recentMFD':
          if (isWellShaped(recentMFDs[index - 1], 'pictureBig')) {
            return true
          }

          return false

        case 'recentOrders':
          if (isWellShaped(recentOrders[index - 1], 'pictureBig')) {
            return true
          }

          return false

        default:
          return false
      }
    }

    return false
  },
)
